module.exports = __webpack_public_path__ + "media/environment.0cde8796.png";